import { httpGet, httpPut, httpDelete } from '../../../Util/http';
import { addAlert } from '../../../MsgNotify/msgNotifyActions';
import update from 'react/lib/update';


export const DEPARTMENT_GET_EMPLOYEES_REQUEST = 'DEPARTMENT_GET_EMPLOYEES_REQUEST';
export const getEmployeesRequest = () => (
    {
        type: DEPARTMENT_GET_EMPLOYEES_REQUEST
    }
)


export const DEPARTMENT_GET_EMPLOYEES_SUCCESS = 'DEPARTMENT_GET_EMPLOYEES_SUCCESS'
export const getEmployeesSuccess = (employees) => (
    {
        type: DEPARTMENT_GET_EMPLOYEES_SUCCESS,
        employees
    }
)


export const DEPARTMENT_GET_EMPLOYEES_FAILURE = 'DEPARTMENT_GET_EMPLOYEES_FAILURE';
export const getEmployeesFailure = () => (
    {
        type: DEPARTMENT_GET_EMPLOYEES_FAILURE
    }
)


export const attemptGetEmployees = (departmentId) => {
    let _url = process.env.REACT_APP_webApiEndPoint + 'api/department/' + departmentId + '/employees';
    return dispatch => {
        dispatch(getEmployeesRequest());
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => {
                dispatch(getEmployeesSuccess(json))
            })
            .catch(() => {
                dispatch(getEmployeesFailure())
                dispatch(addAlert("Kunne ikke hente medarbejdere"))
            })
    };
}




export const GET_EMPLOYEE_SUGGESTIONS_SUCCESS = 'GET_EMPLOYEE_SUGGESTIONS_SUCCESS';
export const getEmployeeSuggestionsSuccess = (suggestions) => (
    {
        type: GET_EMPLOYEE_SUGGESTIONS_SUCCESS,
        suggestions: suggestions
    }
)

function stripSuggestions(suggestions, alreadyChosen) {
    var newSuggestions = [];
    suggestions.forEach(function (suggestion) {
        var allowedSugg = true;
        //check if already chosen from suggestions
        alreadyChosen.forEach(function (chosen) {
            if (chosen.id===suggestion.id || chosen===suggestion.id) allowedSugg = false;
        });
        if (allowedSugg) newSuggestions.push(suggestion);
    })
    return newSuggestions;
}

export const getEmployeeSuggestions = (val) => {
    let fetchUrl = process.env.REACT_APP_webApiEndPoint + "/api/employee/search?query=" + val
    return (dispatch, getState) => {
        if (!val) {
            dispatch(getEmployeeSuggestionsSuccess([]))
            return;
        }
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                let alreadyChosen = getState().employeeListViewReducer.employees;
                let jsonReponse = stripSuggestions(json, alreadyChosen)
                dispatch(getEmployeeSuggestionsSuccess(jsonReponse))
            })
            .catch((e) => {
                console.log(e);
            })
    };
}



export const DEPARTMENT_ADD_EMPLOYEE_REQUEST = 'DEPARTMENT_ADD_EMPLOYEE_REQUEST'
export const departmentAddEmployeeRequest = (employee) => (
    {
        type: DEPARTMENT_ADD_EMPLOYEE_REQUEST,
        employee: { ...employee, initials: "" }
    }
)


export const DEPARTMENT_ADD_EMPLOYEE_SUCCESS = 'DEPARTMENT_ADD_EMPLOYEE_SUCCESS'
export const departmentAddEmployeeSuccess = (employeeInitials) => (
    {
        type: DEPARTMENT_ADD_EMPLOYEE_SUCCESS,
        employeeInitials
    }
)

export const attemptAddEmployee = (employee, departmentId) => {
    return (dispatch) => {
        let _url = process.env.REACT_APP_webApiEndPoint + 'api/employee/' + employee.id + '/department';
        dispatch(departmentAddEmployeeRequest(employee));
        dispatch(getEmployeeSuggestionsSuccess([]))
        return httpPut(_url, { departmentId: departmentId })
            .then(response => {
                return response.json();
            })
            .then((obj) => {
                dispatch(departmentAddEmployeeSuccess(obj.initials))
            })
            .catch(() => {
                dispatch(rmEmployeeFromDepartmentSuccess(0));
                dispatch(addAlert("Kunne ikke tilføje mearbejderen"))
            })
    };
}


export const REMOVE_EMPLOYEE_FROM_DEPARTMENT = 'REMOVE_EMPLOYEE_FROM_DEPARTMENT'
export const rmEmployeeFromDepartmentSuccess = (employeeIndex) => (
    {
        type: REMOVE_EMPLOYEE_FROM_DEPARTMENT,
        employeeIndex
    }
)

export const rmEmployeeFromDepartment = (employeeIndex, departmentId) => {
    return (dispatch, getState) => {

        let employee = getState().employeeListViewReducer.employees[employeeIndex];

        let _url = process.env.REACT_APP_webApiEndPoint + 'api/employee/' + employee.id + '/department';

        return httpDelete(_url, { departmentId: departmentId })
            .then(() => dispatch(rmEmployeeFromDepartmentSuccess(employeeIndex)))
            .catch(() => {
                dispatch(addAlert("Der skete en fejl, medarbejderen kunne ikke fjernes."))
            })
    };
}


export const SET_EMPLOYEE_IS_DRAGGING = 'SET_EMPLOYEE_IS_DRAGGING'
export function setEmployeeIsDragging(employeeId) {
    return {
        type: SET_EMPLOYEE_IS_DRAGGING,
        employeeId
    };
}




export const DEPARTMENT_MOVE_EMPLOYEE_REQUEST = 'DEPARTMENT_MOVE_EMPLOYEE_REQUEST'
export function moveEmployeeRequest(employees) {
    return {
        type: DEPARTMENT_MOVE_EMPLOYEE_REQUEST,
        employees: employees
    }
}

export const DEPARTMENT_MOVE_EMPLOYEE_SUCCESS = 'DEPARTMENT_MOVE_EMPLOYEE_SUCCESS'
export function moveEmployeeSuccess() {
    return {
        type: DEPARTMENT_MOVE_EMPLOYEE_SUCCESS
    }
}

export const DEPARTMENT_MOVE_EMPLOYEE_FAILURE = 'DEPARTMENT_MOVE_EMPLOYEE_FAILURE'
export function moveEmployeeFailure(employees) {
    return {
        type: DEPARTMENT_MOVE_EMPLOYEE_FAILURE,
        employees: employees
    }
}


export function attemptMoveEmployee(employeeIndex, newIndex, departmentId) {
    return (dispatch, getState) => {
        let _url = process.env.REACT_APP_webApiEndPoint + "api/department/" + departmentId + "/employees/sort";
        let employees = getState().employeeListViewReducer.employees;
        let emp = employees[employeeIndex]
        let emp1 = update(employees, {
            $splice: [[employeeIndex, 1]]
        });
        let newEmployees = update(emp1, {
            $splice: [[newIndex > employeeIndex ? newIndex - 1 : newIndex, 0, emp]]
        });
        dispatch(moveEmployeeRequest(newEmployees))
        let payLoad = newEmployees.map(employee => {
            return employee.id
        })
        return httpPut(_url, payLoad)
            .then(() => dispatch(moveEmployeeSuccess()))
            .catch(() => {
                dispatch(moveEmployeeFailure(employees))
                dispatch(addAlert("Der skete en fejl, medarbejderen kunne ikke flyttes"))
            })
    };
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/EmployeeListView/actions.js